import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { Field, reduxForm, propTypes, formValueSelector, getFormSyncErrors, change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { savingSeasonSetup, saveSeasonSetup, resetSetupSettings } from "../../../redux/actions/seasonActions"
import { style,states,blue } from '../../../utils/constants'
import { onlypositivenumbers } from '../../../utils/functions/onlypositivenumbers'
import { renderSelectField } from '../../../modules/components/selectfieldcomponent'
import { renderDatePickerField } from '../../../modules/components/datepickercomponent'
import { renderField } from '../../../modules/components/fieldcomponent'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName = 'seasonsetup'
const setupTab = 3

class Setup extends Component {
	static propTypes = {
		...propTypes
	}
	constructor(props,context) {
		super(props,context)
		this.handleSaveSetup = this.handleSaveSetup.bind(this) 
		this.handleValueChange = this.handleValueChange.bind(this)
	}
	componentDidUpdate() {
		const {  initialize,datasaved,resetform,resetSetupSettings,settingsSaved ,setupreset,resetDone,dispatch } = this.props
		if (datasaved) {
			initialize({}, true)
			settingsSaved(true,setupTab)
		}
		if(resetform == true){
			resetSetupSettings()
		}
		if(setupreset == true){
			dispatch(change(formName,'setupreset',false))
			resetDone()
		}
	}
	handleSaveSetup() {
		const { setup, saveSeasonSetup, settingsseason, dispatch } = this.props
		const seasonsettings = setup[settingsseason]      
		const seasonsetup = {
			leagueMinGames:seasonsettings.leagueMinGames,
			tournamentMinGames:seasonsettings.tournamentMinGames,
			tournamentDate:seasonsettings.tournamentDate,
			tournamentCity:seasonsettings.tournamentCity,
			tournamentState:seasonsettings.tournamentState,
			seasonId:settingsseason,
		}
		dispatch(savingSeasonSetup());
		saveSeasonSetup(settingsseason,seasonsetup)
	}
	handleValueChange(){
		const { dispatch, settingsSaved } = this.props
		dispatch(change(formName,'datasaved',false))
		settingsSaved(false,setupTab)
	}
	render() {
		
		const { setup,settingsseason,savingsetup,datasaved,seasonyears, syncErrors } = this.props
		const season = `setup[${settingsseason}]`
		const errors =  Object.values(syncErrors)
		let isSeasonSet = true
		const moveLeft  = {
			marginLeft: '-40px' 
		}	
		if(setup){
			isSeasonSet = setup[settingsseason].isSeasonSet
		}

		return (
			<Row className="center-block center-text">
				<form className="form-horizontal" sm={12} style={{ padding:'0',margin:'0' }} >
					<Col sm={12}>
						<FormGroup>
							<SeasonHeader seasonyears={seasonyears} />   
						</FormGroup>
						{ (errors.length > 0) && <ErrorList errors={errors}/> }
						<FormGroup>
							<label className={style.lblattrs5}>League - min # games &nbsp;</label>
							<Field
								type='number'
								name={`${season}.leagueMinGames`}
								component='input'
								max={99}
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={onlypositivenumbers}
								onChange={this.handleValueChange}                                        
							/>
						</FormGroup>
						<FormGroup>
							<label className={style.lblattrs5}>Tournament - min # games &nbsp;</label>
							<Field
								type='number'
								name={`${season}.tournamentMinGames`}
								component='input'
								max={99}
								className="form-control no-spinners"
								style={{ maxWidth: '70px' }}
								onKeyDown={onlypositivenumbers}
								onChange={this.handleValueChange}                                        
							/>
						</FormGroup>
						<FormGroup  style={moveLeft}>
							<label className={style.lblattrs5}>Tournament Start Date &nbsp;</label>
							<Field
								name={`${season}.tournamentDate`}
								component={renderDatePickerField}
								placeholder='mm-dd-yyyy'
								inputattrs = {style.inputattrs5}
								onChange={this.handleValueChange}								
							/>
						</FormGroup>
						<FormGroup style={moveLeft}>
							<label className={style.lblattrs5}>Tournament City &nbsp;</label>
							<Field
								name={`${season}.tournamentCity`}
								component={renderField}
								inputattrs = {style.inputattrs4}
								onChange={this.handleValueChange}                                        
							/>
						</FormGroup>
						<FormGroup style={moveLeft}>
							<label className={style.lblattrs5}>State &nbsp;</label>
							<Field
								name={`${season}.tournamentState`}
								component={renderSelectField}
								inputattrs = {style.inputattrs4}  
								prompt='Select a state'
								values = {states}								
								onChange={this.handleValueChange}               
							/>
						</FormGroup>
					
						<FormGroup>
							<Col smOffset={ 5 } sm={ 6 }>
								<button type="button"   className="btn btn-default" style={{ color: blue, fontWeight: 800 }} onClick={this.handleSaveSetup} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
										<i className={savingsetup == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
								</button>
								{
										datasaved && (<InfoSaved section='Season setup' />)
								}
							</Col>
						</FormGroup>
					</Col>
				</form>                                
		</Row>)
	}
}

function validate(values) {
    const { setup, settingsseason } = values    
   
    const errors = {}
 
    if(setup && settingsseason){
        const season = setup[settingsseason]
        const { leagueMinGames, tournamentMinGames , tournamentCity, tournamentState, isSeasonSet } = season
        let errorCounter = 0
            
            if (isSeasonSet) {
    
                // check all values are provided
                if (!leagueMinGames) {
                    errors[errorCounter++] = "League Min # games is required"
                }
                if (!tournamentMinGames) {
                    errors[errorCounter++] = "Tournament Min # games is required"
                }
                if (!tournamentCity) {
                    errors[errorCounter++] = "Tournament City is required"
                }                
                if (tournamentState == "-1") {                                        
                    errors[errorCounter++] = "Tournament State is required"
				}
          }
          else {
            errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
          }
    }    
    return errors
}
Setup.propTypes = {
	dispatch:PropTypes.func,
	initialize:PropTypes.func,
	syncErrors:PropTypes.object,
	settingsseason:PropTypes.number,
	savingsetup:PropTypes.bool,
	datasaved:PropTypes.bool,
	seasonyears:PropTypes.string,
	setup:PropTypes.object,
	savingSeasonSetup: PropTypes.func,
	saveSeasonSetup: PropTypes.func,
	resetSetupSettings: PropTypes.func,
	settingsSaved: PropTypes.func,
	resetform:PropTypes.bool,
	resetDone:PropTypes.func,
	setupreset:PropTypes.bool,
}
function mapStateToProps(state,ownProps){   
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const settingsseason = selector(state,'settingsseason')
	const setup     = selector(state,'setup')
	const setupreset     = selector(state,'setupreset')
	const savingsetup     = selector(state,'savingsetup')
	const datasaved     = selector(state,'datasaved')
	const syncErrors = getFormSyncErrors(formName)(state)
	return {     
		settingsseason,
		setup,
		setupreset,
		savingsetup,
		datasaved,
		syncErrors  
	}
}
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		savingSeasonSetup,
		saveSeasonSetup,
		resetSetupSettings,
	},dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Setup))




// WEBPACK FOOTER //
// ./src/containers/season/components/Setup.js